import React, { useState } from 'react';
import moment from 'moment-timezone';

import CardLayout from '@magoosh/layouts/card';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import ContentCard from '../../components/content_card';
import SectionHeader from '../../components/section_header';
import TextAsParagraphs from '../../components/text_as_paragraphs';
import { Answer } from '../../../types';

import FeedbackChatBubble from '../../assets/feedback_chat_bubble.svg';


interface Props {
  answer: Answer;
}

export default (props) => {
  const [promptExpanded, setPromptExpanded] = useState(false);

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  return (
    <CardLayout.Card className="d-flex flex-column flex-md-row gap-m gap-lg-xl">
      <SectionHeader
        supertitle="Prompt and response"
        supertitleIcon="file-text"
        title="What you wrote"
      />

      <div className="d-flex flex-1 flex-column gap-m" style={{ minWidth: 0 }}>
        <ContentCard className="d-flex flex-1 flex-column gap-m">
          <div
            className="align-items-center d-flex gap-s"
            onClick={() => setPromptExpanded(!promptExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <div className="flex-1">
              <strong>Prompt</strong>
            </div>

            <div>
              <strong>
                <FontAwesomeIcon icon={promptExpanded ? 'minus' : 'plus'} />
              </strong>
            </div>
          </div>

          <div className="d-flex flex-column gap-m small">
            {
              promptExpanded ? (
                <div
                  className="answer"
                  dangerouslySetInnerHTML={{ __html: props.answer.prompt.content.html }}
                />
              ) : (
                <div
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {props.answer.prompt.content.text}
                </div>
              )
            }
          </div>
        </ContentCard>

        <ContentCard className="d-flex flex-1 flex-column gap-m">
          <div className="align-items-center d-flex gap-s">
            <img alt="" src={FeedbackChatBubble} />
            <span className="small">
              You on {moment.unix(props.answer.createdAt).tz(timeZone).format('MMMM D, YYYY')}
            </span>
          </div>

          <div>
            <TextAsParagraphs text={props.answer.response.text} />
          </div>
        </ContentCard>
      </div>
    </CardLayout.Card>
  );
};
